export const CLASSIFICATION_MODAL_OPEN = 'ResolutionCenter/AccountTakeOverClassificationModal/OPEN'
export const CLASSIFICATION_MODAL_CLOSE =
  'ResolutionCenter/AccountTakeOverClassificationModal/CLOSE'
